// extracted by mini-css-extract-plugin
export var actionText = "_kt-4";
export var container = "_kt-0";
export var leftSection = "_kt-1";
export var rightSection = "_kt-2";
export var settingsButton = "_kt-6";
export var settingsIcon = "_kt-7";
export var shortcut = "_kt-5";
export var shortcutGroup = "_kt-3";